import React from 'react'
import { Box, Button } from '@mui/material'
import { useToggleState } from 'shared/hooks'
import { INode } from 'shared/types/tree'
import { NodeCreation } from 'components/tree/utility/NodeCreation'

type CreationParams = {
  node: INode
  onCreate: () => void
}

export function NodeCreationToggle({ node, onCreate }: CreationParams) {
  const [adding, setAdding] = useToggleState()

  const doOnCreate = () => {
    onCreate()
    setAdding(false)
  }

  if (adding) {
    return (
      <Box>
        <Button onClick={() => setAdding()}>Cancel</Button>
        <NodeCreation node={node} onCreate={doOnCreate} />
      </Box>
    )
  }
  return <Button onClick={() => setAdding()}>Add Child Node</Button>
}
